const toFixed = (number: number, precision: number): string => {
    return (+(Math.round(+(number + 'e' + precision)) + 'e' + -precision)).toFixed(precision)
}

export const formatNumber = (value: number | null, hideDecimalsWhenInteger = false): string =>
    toFixed(parseFloat((value || 0).toString()), hideDecimalsWhenInteger ? ((value || 0) % 1 === 0 ? 0 : 2) : 2)
